import React, { useState } from "react"
import { StyleSheet, Text, View } from "react-native"
import DateIntervalButtons from "../../components/DateIntervalButtons"
import NextButton from "../../components/NextButton"
import { exportDiary } from "../../actions/headerItemActions"

import Screen from "../../components/Screen"
import { statusEnum } from "../../data/enums"
import { useStatus } from "../../providers/StatusProvider"
import { useData } from "../../providers/DataProvider"

export default function DiaryExport({ navigation, route }) {
  const { setTitle, setStatus, setMessage } = useStatus()
  const today = new Date()
  const [dateInterval, setDateInterval] = useState({
    from: new Date(today.getFullYear(), today.getMonth() - 1, 1),
    to: new Date(today.getFullYear(), today.getMonth(), 0),
  })
  const { firebaseConfig } = useData()
  const projectId = route.params.projectId

  async function handleExportDiary() {
    try {
      const { from, to } = dateInterval
      const f = from.getFullYear() + "-" + (from.getMonth() + 1) + "-" + from.getDate()
      const t = to.getFullYear() + "-" + (to.getMonth() + 1) + "-" + to.getDate()

      setTitle("Generuji stavební deník do PDF")
      setStatus(statusEnum.PROGRESS_UNDETERMINED)
      navigation.navigate("StatusScreen")

      const { message, status: exportStatus } = await exportDiary(projectId, { from: f, to: t }, firebaseConfig)

      console.debug("EXPORTED STATUS", exportStatus)
      setStatus(exportStatus)
      setMessage(message)
      navigation.pop()
    } catch (error) {
      setStatus(statusEnum.ERROR)
      setMessage(error.message)
    }
  }

  return (
    <Screen>
      <DateIntervalButtons dateInterval={dateInterval} fullScreen setDateInterval={setDateInterval} />
      <NextButton text="Exportovat" onPress={handleExportDiary} disabled={dateInterval.from > dateInterval.to} />
    </Screen>
  )
}
